import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Brasao } from "../../components/Layout";
import { api, entrarComoCandidato, fmt, type ErroApi } from "../../lib/api";

/**
 * Pra quem já tinha inscrição de antes do login existir (ou de outro ano):
 * confirma CPF + data de nascimento — dado que já está no cadastro — e
 * define a senha. Mesmo endpoint de {@code CriarSenha}, só que sem dados
 * pré-preenchidos pela navegação.
 */
export function PrimeiroAcesso() {
  const [cpf, setCpf] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const navigate = useNavigate();

  async function enviar(ev: FormEvent) {
    ev.preventDefault();
    setErro(null);

    if (senha.length < 8) {
      setErro("A senha deve ter pelo menos 8 caracteres.");
      return;
    }
    if (senha !== confirmacao) {
      setErro("As senhas não conferem.");
      return;
    }

    setEnviando(true);
    try {
      await api.post("/api/publico/candidatos/senha", {
        cpf: cpf.replace(/\D/g, ""), dataNascimento, senhaNova: senha,
      });
      await entrarComoCandidato(cpf.replace(/\D/g, ""), senha);
      navigate("/area");
    } catch (e) {
      const err = e as ErroApi;
      setErro(err.motivos[0] ?? err.mensagem);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="tema-candidato tc-entrada">
      <div className="tc-entrada-corpo">
        <div className="tc-entrada-caixa">
          <div className="linha" style={{ justifyContent: "center", marginBottom: 8 }}>
            <Brasao tamanho={32} />
          </div>

          <form onSubmit={enviar} className="tc-cartao" noValidate>
            <h1 className="tc-titulo">Primeiro acesso</h1>
            <p className="tc-ajuda">
              Se você já se inscreveu neste processo seletivo antes da área de login existir,
              confirme seu CPF e data de nascimento pra criar sua senha.
            </p>

            {erro && <div className="tc-erro" role="alert">{erro}</div>}

            <div className="tc-campo">
              <label htmlFor="cpf">CPF</label>
              <input id="cpf" value={cpf} inputMode="numeric" required
                     onChange={(e) => setCpf(fmt.cpf(e.target.value))} />
            </div>

            <div className="tc-campo">
              <label htmlFor="nascimento">Data de nascimento</label>
              <input id="nascimento" type="date" value={dataNascimento} required
                     onChange={(e) => setDataNascimento(e.target.value)} />
            </div>

            <div className="tc-campo">
              <label htmlFor="senha">Nova senha</label>
              <input id="senha" type="password" value={senha} required minLength={8}
                     autoComplete="new-password" onChange={(e) => setSenha(e.target.value)} />
            </div>

            <div className="tc-campo">
              <label htmlFor="confirmacao">Confirme a senha</label>
              <input id="confirmacao" type="password" value={confirmacao} required
                     autoComplete="new-password" onChange={(e) => setConfirmacao(e.target.value)} />
            </div>

            <button type="submit" className="tc-btn tc-btn-primario tc-btn-largo" disabled={enviando}>
              {enviando ? "Confirmando..." : "Criar senha e entrar"}
            </button>
          </form>

          <div className="tc-links">
            <Link to="/entrar">Já tenho senha</Link>
            <Link to="/inscricao">Nunca me inscrevi</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
